import Swiper from "swiper/bundle";
import { Autoplay, EffectFade } from "swiper/modules";
import 'swiper/css/bundle';
import GET_ARTICLES from "../class/getArticles"; 

export default function RECRUIT() {

  setTimeout(() => {

    // 左側のスライダーA
    const swiperA = new Swiper('.slider-A', {
      modules: [Autoplay, EffectFade], 
      effect: 'fade', 
      fadeEffect: {
        crossFade: true,
      },
      loop: true,
      speed: 1100,
      autoplay: {
        delay: 2000,
        disableOnInteraction: false,
      },
    });

    // 右側のスライダーB
    const swiperB = new Swiper('.slider-B', {
      modules: [Autoplay, EffectFade], 
      effect: 'fade', 
      fadeEffect: {
        crossFade: true,
      },
      loop: true,
      speed: 1100, 
      autoplay: {
        delay: 2300,
        disableOnInteraction: false,
      },
    });
  }, 100);


  setTimeout(() => {

    // 記事リストの初期化
    const getArticle = new GET_ARTICLES('.recruit_provided__list');
    getArticle.makeItem = (item) => {
      if (item.id === '12') {
        return ''; 
      }
      return `
      <li>
        <a href="${item.href}" class="block-news__link">
          <figure class="thumb">
            <img src="${item.thumb}" alt="${item.title}" width="100%" loading="lazy">
          </figure>
          <div class="text_wrap">
            <span class="cate">${item.category.name}</span>
            <p class="ttl${(item.is_new) ? ' is-new' : ''}"><span>${item.title}</span></p>
            <span class="sub_ttl">${item.desc && item.desc.length > 200 ? item.desc.slice(0, 200) + '...' : (item.desc || '')}</span>
          </div> 
          <img class="arrow" src="/assets/svg/icon_arrow.svg" alt="矢印">
        </a>
      </li>`;
    };
    getArticle.render();

    setTimeout(() => {
      if (window.location.hash === '#provided') {
        const target = document.querySelector('#provided');
        if (target) {
          const headerHeight = 100; 
          
          const targetPosition = target.getBoundingClientRect().top + window.pageYOffset - headerHeight + 100;
          
          window.scrollTo({
            top: targetPosition,
            behavior: 'smooth' 
          });
        }
      }
    }, 300);


    const categoryContainer = document.querySelectorAll('.block-news [data-plugin="getCategories"]');
    
    categoryContainer.forEach(obj => {
      let contentParam = obj.getAttribute('data-content') || 'news';
      contentParam = contentParam.replace(/[\(\)\{\}\$]/g, '').split('.').pop() || 'news';
      
      if (contentParam.includes('MODULE_TITLE')) {
        contentParam = 'news';
      }

      if (typeof getArticle.fetchCategories === 'function') {
        getArticle.fetchCategories(contentParam).then(res => {

          let catsArray = [];
          if (Array.isArray(res)) {
            catsArray = res;
          } else if (res && Array.isArray(res.data)) {
            catsArray = res.data;
          } else if (res && typeof res === 'object') {
            catsArray = Object.values(res);
          }

          const catAll = {
            id: 'all', href: '/news/?mode=list', name: 'ALL', turn: 0
          };
          
          const allCats = [catAll, ...catsArray];
          
          const makeHTML = catItem => {
            const id = catItem.id || catItem.term_id || 'default';
            const href = catItem.href || `/news/?cate=${id}`;
            const name = catItem.name || catItem.title || '';
            return `<li class="block-news__tag-item"><a class="block-news__tag-link is-${id}" href="${href}">${name}</a></li>`;
          };
          
          obj.innerHTML = '';
          allCats.forEach(catItem => obj.insertAdjacentHTML('beforeend', makeHTML(catItem)));
          
        }).catch(err => {
          console.error("カテゴリのデータ取得に失敗しました:", err);
        });
      } else {
        console.warn("⚠️ getArticle内に fetchCategories メソッドが見つかりません。");
      }
    });
  }, 100);
}